import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'kn',
  Pagination: {
    items_per_page: '/ ಪುಟ',
    jump_to: 'ಜಿಗಿತವನ್ನು',
    jump_to_confirm: 'ಖಚಿತಪಡಿಸಲು ಜಿಗಿತವನ್ನು',
    page: '',
    prev_page: 'ಹಿಂದಿನ ಪುಟ',
    next_page: 'ಮುಂದಿನ ಪುಟ',
    prev_5: 'ಹಿಂದಿನ 5 ಪುಟಗಳು',
    next_5: 'ಮುಂದಿನ 5 ಪುಟಗಳು',
    prev_3: 'ಹಿಂದಿನ 3 ಪುಟಗಳು',
    next_3: 'ಮುಂದಿನ 3 ಪುಟಗಳು',
  },
  DatePicker: {
    lang: {
      placeholder: 'ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
      rangePlaceholder: [
        'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        'ಅಂತಿಮ ದಿನಾಂಕ',
      ],
      locale: 'kn_IN',
      today: 'ಇಂದು',
      now: 'ಈಗ',
      backToToday: 'ಇಂದು ಹಿಂದಿರುಗಿ',
      ok: 'ಸರಿ',
      clear: 'ಸ್ಪಷ್ಟ',
      month: 'ತಿಂಗಳು',
      year: 'ವರ್ಷ',
      timeSelect: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
      dateSelect: 'ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
      weekSelect: 'ಒಂದು ವಾರದ ಆರಿಸಿ',
      monthSelect: 'ಒಂದು ತಿಂಗಳು ಆಯ್ಕೆಮಾಡಿ',
      yearSelect: 'ಒಂದು ವರ್ಷ ಆರಿಸಿ',
      decadeSelect: 'ಒಂದು ದಶಕದ ಆಯ್ಕೆಮಾಡಿ',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ಹಿಂದಿನ ತಿಂಗಳು (ಪೇಜ್ಅಪ್)',
      nextMonth: 'ಮುಂದಿನ ತಿಂಗಳು (ಪೇಜ್ಡೌನ್)',
      previousYear: 'ಕಳೆದ ವರ್ಷ (Ctrl + ಎಡ)',
      nextYear: 'ಮುಂದಿನ ವರ್ಷ (Ctrl + ಬಲ)',
      previousDecade: 'ಕಳೆದ ದಶಕ',
      nextDecade: 'ಮುಂದಿನ ದಶಕ',
      previousCentury: 'ಕಳೆದ ಶತಮಾನ',
      nextCentury: 'ಮುಂದಿನ ಶತಮಾನ',
    },
    timePickerLocale: {
      placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
    },
  },
  TimePicker: {
    placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
  },
  Calendar: {
    lang: {
      placeholder: 'ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ',
      rangePlaceholder: [
        'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
        'ಅಂತಿಮ ದಿನಾಂಕ',
      ],
      locale: 'kn_IN',
      today: 'ಇಂದು',
      now: 'ಈಗ',
      backToToday: 'ಇಂದು ಹಿಂದಿರುಗಿ',
      ok: 'ಸರಿ',
      clear: 'ಸ್ಪಷ್ಟ',
      month: 'ತಿಂಗಳು',
      year: 'ವರ್ಷ',
      timeSelect: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
      dateSelect: 'ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
      weekSelect: 'ಒಂದು ವಾರದ ಆರಿಸಿ',
      monthSelect: 'ಒಂದು ತಿಂಗಳು ಆಯ್ಕೆಮಾಡಿ',
      yearSelect: 'ಒಂದು ವರ್ಷ ಆರಿಸಿ',
      decadeSelect: 'ಒಂದು ದಶಕದ ಆಯ್ಕೆಮಾಡಿ',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ಹಿಂದಿನ ತಿಂಗಳು (ಪೇಜ್ಅಪ್)',
      nextMonth: 'ಮುಂದಿನ ತಿಂಗಳು (ಪೇಜ್ಡೌನ್)',
      previousYear: 'ಕಳೆದ ವರ್ಷ (Ctrl + ಎಡ)',
      nextYear: 'ಮುಂದಿನ ವರ್ಷ (Ctrl + ಬಲ)',
      previousDecade: 'ಕಳೆದ ದಶಕ',
      nextDecade: 'ಮುಂದಿನ ದಶಕ',
      previousCentury: 'ಕಳೆದ ಶತಮಾನ',
      nextCentury: 'ಮುಂದಿನ ಶತಮಾನ',
    },
    timePickerLocale: {
      placeholder: 'ಸಮಯ ಆಯ್ಕೆಮಾಡಿ',
    },
  },
  global: {
    placeholder: 'ದಯವಿಟ್ಟು ಆರಿಸಿ',
  },
  Table: {
    filterTitle: 'ಪಟ್ಟಿ ಸೋಸಿ',
    filterConfirm: 'ಸರಿ',
    filterReset: 'ಮರುಹೊಂದಿಸಿ',
    emptyText: 'ಮಾಹಿತಿ ಇಲ್ಲ',
    selectAll: 'ಪ್ರಸ್ತುತ ಪುಟವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectInvert: 'ಪ್ರಸ್ತುತ ಪುಟವನ್ನು ತಿರುಗಿಸಿ',
    sortTitle: 'ವಿಂಗಡಿಸಿ',
  },
  Modal: {
    okText: 'ಸರಿ',
    cancelText: 'ರದ್ದು',
    justOkText: 'ಸರಿ',
  },
  Popconfirm: {
    okText: 'ಸರಿ',
    cancelText: 'ರದ್ದು',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    notFoundContent: 'ದೊರೆತಿಲ್ಲ',
    searchPlaceholder: 'ಇಲ್ಲಿ ಹುಡುಕಿ',
    itemUnit: 'ವಿಷಯ',
    itemsUnit: 'ವಿಷಯಗಳು',
  },
  Select: {
    notFoundContent: 'ದೊರೆತಿಲ್ಲ',
  },
  Upload: {
    uploading: 'ಏರಿಸಿ...',
    removeFile: 'ಫೈಲ್ ತೆಗೆದುಹಾಕಿ',
    uploadError: 'ಏರಿಸುವ ದೋಷ',
    previewFile: 'ಫೈಲ್ ಮುನ್ನೋಟ',
    downloadFile: 'ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
  },
};

export default localeValues;
